module.exports = __webpack_public_path__ + "static/media/17-Draycott-Place.d2988eeb.mp4";